/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-unfetch';
import config from '../../config';

const { apiHost } = config;

export const fetchHomepageContent = previewToken => async (dispatch) => {
    // console.log('fetchHomepageContent');
    dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_REQUEST' });
    if (previewToken) {
        try {
            return await fetch(`${apiHost}/v1/content/fetchhomepagecontent?token=${previewToken}`)
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_FAILURE', data: data.error });
                    } else {
                        dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_SUCCESS', data });
                    }
                });
        } catch (error) {
            dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_FAILURE' });
        }
    } else {
        try {
            return await fetch(`${apiHost}/v1/content/fetchhomepagecontent`)
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_FAILURE', data: data.error });
                    } else {
                        dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_SUCCESS', data });
                    }
                });
        } catch (error) {
            dispatch({ type: 'HOMEPAGE_CONTENT:FETCH_CONTENT_FAILURE' });
        }
    }
};
